function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function updateReviews() {
    reviewOptions = [[2, 5], [1, 5], [4, 5], [1, 2], [3, 4], [2, 3], [1, 3], [3, 5], [2, 4], [1, 4]];
    reviewOptions[parseInt(document.querySelector('.jdgm-paginate__page.jdgm-curt').innerText) % reviewOptions.length].forEach(it => {
        document.querySelectorAll(".jdgm-rev")[it - 1] && document.querySelectorAll(".jdgm-rev")[it - 1].setAttribute('data-verified-buyer', true);
        document.querySelectorAll(".jdgm-rev__author")[it - 1].insertAdjacentHTML('afterEnd', '<span class="jdgm-rev__buyer-badge-wrapper"> <span class="jdgm-rev__buyer-badge"></span> </span>');
    });
}

waitForElm('.jdgm-curt').then((elm) => {
    updateReviews();
    const targetNode = document.querySelector(".jdgm-rev-widg__paginate-spinner-wrapper");

    const config = { attributes: true, childList: false, subtree: false };

    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            console.log(mutation.target.style.display);
            if (mutation.type === "attributes" && mutation.target.style.display === "none") {
                updateReviews();
            }
        }
    };

    const reviewObserver = new MutationObserver(callback);
    reviewObserver.observe(targetNode, config);
});